import React from "react";
import { Box, Button, Text, Spinner, ModalBody, ModalFooter } from "@chakra-ui/react";
import { FZCLIcon } from "@/components/ui/fzcl/Icon";
import { ClasswizeModal } from "@/components/ui/Modal";

interface Props {
	name: string;
	isDeleting: boolean;
	isOpen: boolean;
	closeModal: () => void;
	handleConfirmDelete: () => void;
}
export function ConfirmDeleteFocusModal(props: Props): JSX.Element {
	return (
		<ClasswizeModal isOpen={props.isOpen} onClose={props.closeModal} title="Delete From Focus Library" size="lg">
			<ModalBody>
				<Text my={4}>
					Are you sure you want to delete your saved focus <strong>&apos;{props.name}&apos;</strong> from your Focus Library?
				</Text>
			</ModalBody>
			<ModalFooter>
				<Box>
					<Button
						variant="danger"
						leftIcon={props.isDeleting ? <Spinner /> : <FZCLIcon icon={"fa-trash-can"} />}
						float={"right"}
						onClick={props.handleConfirmDelete}
						isDisabled={props.isDeleting}
					>
						{props.isDeleting ? "Deleting" : "Delete"}
					</Button>
				</Box>
			</ModalFooter>
		</ClasswizeModal>
	);
}
